import { defaultTooltipContextValue } from '../types/defaultTooltipContextValue';
/**
 * The event handler for the close tooltip synthetic event.
 *
 * @template C Content data type
 * @param {SetTooltipSettingsDebounced<C>} setTooltipSettingsDebounced
 * @param {Dispatch<SetStateAction<TooltipSettings>>} setTooltipSettings
 * @returns {() => void} Event handler to be used in addEventListener
 */
export var closeTooltipEventHandler = function (setTooltipSettingsDebounced, setTooltipSettings) {
    return function () {
        setTooltipSettingsDebounced.cancel();
        setTooltipSettings(defaultTooltipContextValue);
    };
};
//# sourceMappingURL=closeTooltipEventHandler.js.map